import React from 'react';

import BVSwitch from '../../../BVControls/BVSwitch/bv-switch';

interface IBVBoolean {
    className?: string;
    label?: string;
    properties: any;
}

const BVBoolean: React.FunctionComponent<IBVBoolean> = ({ className, label, properties }) => (
    <BVSwitch className={className} label={label} properties={properties} />
);

export default BVBoolean;